import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useNativeDeviceType } from '~/context/common/DeviceContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useResizeListener, useTrackClickEvents } from '~/hooks/common';
import { useGetFavorites } from '~/hooks/common/favorites';
import { useGetTrades } from '~/hooks/common/services';
import useGetCreditStatus from '~/hooks/home/useGetCreditStatus';
import useGetNextBestAction from '~/hooks/home/useGetNextBestAction';
import useGetRecentSearches from '~/hooks/home/useGetRecentSearches';
import useGetRecentVehicles from '~/hooks/home/useGetRecentVehicles';
import useGetSavedSearches from '~/hooks/home/useGetSavedSearches';
import useSendExperimentsToDataDog from '~/hooks/home/useSendExperimentsToDataDog';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/home';

export default function HomeData() {
  const isLoggedIn = useIsLoggedIn();
  const nativeDeviceType = useNativeDeviceType();

  useGetCreditStatus(isLoggedIn);
  useGetNextBestAction();
  useResizeListener(legacySizes);
  useGetRecentSearches();
  useGetRecentVehicles();
  useGetFavorites();
  useGetSavedSearches();
  useGetTrades(isLoggedIn);
  useSendExperimentsToDataDog();
  useTrackClickEvents();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);

  return null;
}
